// TODO: Fix this, this might fail when there is no window object

const windowAvailable = (encodedCustomCode, window) => {
  try {
    return window.decodeURI(window.atob(encodedCustomCode));
  } catch (error) {
    return "";
  }
};

export const decodeCustomCode = encodedCustomCode => {
  if (typeof window !== "undefined") {
    return windowAvailable(encodedCustomCode, window);
  }
};
